import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../app/hooks";
import { fetchLanguageSkills } from "../features/languageSkills/languageSkillsSlice";
import { LanguageCode } from "../features/localized/localizedApi";
import useMessage from "./useMessage";

const useLanguageSkillsQuery = (enabled = true) => {
  const { t, i18n } = useTranslation();
  const { sendMessage } = useMessage();
  const dispatch = useAppDispatch();

  const UILanguage = i18n.language.substring(0, 2);

  useEffect(() => {
    if (!enabled || !UILanguage) return;
    dispatch(
      fetchLanguageSkills({ language: UILanguage as LanguageCode }),
    ).catch((error) => {
      sendMessage(t(error.message), "error");
    });
    // sendMessage, t is missing from dependencies, but it is a function that is not supposed to change
    // adding it to dependencies causes unnecessary fetches
    // eslint-disable-next-line
  }, [UILanguage, dispatch, enabled]);
};

export default useLanguageSkillsQuery;
